import { getRealestateType } from "@/modules/contract/helper/table"

export const FO_STATUS = [
  { label: 'Sắp diễn ra', value: 'coming_soon' },
  { label: 'Đang diễn ra', value: 'ongoing' },
  { label: 'Đã kết thúc', value: 'ended' },
  { label: 'Đã hủy', value: 'canceled' },
]

export const getStatusFlashOffer = (status: string) => {
  //return TagCell
  switch (status) {
    case 'ongoing':
      return [{
        type: 'info',
        label: 'Đang diễn ra'
      }]
    case 'coming_soon':
      return [{
        type: 'warn',
        label: 'Sắp diễn ra'
      }]
    case 'ended':
      return [{
        type: 'secondary',
        label: 'Đã kết thúc'
      }]
    case 'canceled':
      return [{
        type: 'secondary',
        label: 'Đã hủy'
      }]
    default:
      return [{
        type: 'info',
        label: 'Đang diễn ra'
      }]
  }
}

export const formatTableDataFlashOfferByBroker = (data: any) => {

  return data.map((item: any) => ({
    ...item,
    id: item?.id,
    started_at: item?.started_at,
    ended_at: item?.ended_at,
    status_text: getStatusFlashOffer(item?.status),
    name: item?.name,
    total_items: item?.total_items,
    created_at: item?.created_at,
    created_by: item?.created_by?.full_name || '-'
  }))
}


export const formatTableDataFlashOffer = (data: any) => {

  return data.map((item: any) => ({
    ...item,
    id: item.id,
    started_at: item.started_at,
    ended_at: item.ended_at,
    status_text: getStatusFlashOffer(item.status),
    name: item.name,
    total_items: item.total_items,
    created_at: item.created_at,
    created_by: item?.created_by?.full_name || '-'
  }))
}

export const getStatusRealEstate = (status: string) => {
  //unlisted: "--", listing: "Đang list", active: "Đang rao", flash_offer: "Flash offer"
  switch (status) {
    case 'listing':
      return [{
        type: 'info',
        label: 'Đang list'
      }]
    case 'unlisted':
      return [{
        type: 'secondary',
        label: '--'
      }]
    case 'active':
      return [{
        type: 'info',
        label: 'Đang rao'
      }]
    case 'flash_offer':
      return [{
        type: 'warn',
        label: 'Flash offer'
      }]
    default:
      return [{
        type: 'secondary',
        label: '--'
      }]
  }
}


export const formatTableDataRealEstate = (data: any) => {
  try {
    return data.map((item: any) => ({
      ...item,
      id: item.id,
      address: item.address,
      region: item,
      status_text: getStatusRealEstate(item.status),
      type: '',//getRealestateType(item.real_estate_type),
      created_at: item.created_at,
    }))
  } catch (e) {
    console.log(115, e)
  }
}

export const formatTableDataFlashOfferDetail = (data: any) => {

  return {
    id: data.id,
    name: data.name,
    started_at: data.started_at,
    ended_at: data.ended_at,
    status_arr: getStatusFlashOffer(data.status),
    status: data.status,
    deposit: data.items[0].deposit,
    province_id: data.items[0].province_id,
    district_id: data.items[0].district_id,
    real_estate_ids: data.items[0].real_estate_ids,
    items: data.items,
  }
}

export const formatTableDataFlashOfferItemDetail = (data: any) => {

  // {
    //         id: 1,
    //         subject: {
    //           thumb: `https://picsum.photos/100?random=${uuid.v4()}`,
    //           title: 'Bán toà nhà văn phòng',
    //           attrs: [{ key: 'Diện tích', val: 300 }, { key: 'Số tầng', val: 5 }, { key: 'Số phòng', val: 10 }],
    //           map: { map_sheet: '30', plot_num: '10' },
    //           region: "Hải Châu, Đà Nẵng",
    //           address: "320 đường 2/9",
    //           owner: {
    //             id: 1,
    //             profile_pic: 'https://images.unsplash.com/photo-1602866813929-6bc4933c7013?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    //             code: '#56333',
    //             full_name: 'Nguyễn Văn A',
    //             phone: '090299849',
    //             email: 'test@yopmail.com'
    //           },
    //           broker: {
    //             id: 1,
    //             profile_pic: 'https://images.unsplash.com/photo-1602866813929-6bc4933c7013?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    //             code: '#56333',
    //             full_name: 'Nguyễn Văn A',
    //             phone: '090299849',
    //             email: 'test@yopmail.com'
    //           },
    //         },
    //         statistic: {
    //           deposit_price: 1000000000,
    //           min_price: 100000000,
    //           max_price: 1000000000,
    //           total: 10
    //         },
    //         deal: {
    //           deal_price: 100000000,
    //           owner: {
    //             id: 1,
    //             profile_pic: 'https://images.unsplash.com/photo-1602866813929-6bc4933c7013?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    //             code: '#56333',
    //             full_name: 'Nguyễn Văn A',
    //             phone: '090299849',
    //             email: 'test@yopmail.com'
    //           },
    //           broker: {
    //             id: 1,
    //             profile_pic: 'https://images.unsplash.com/photo-1602866813929-6bc4933c7013?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    //             code: '#56333',
    //             full_name: 'Nguyễn Văn A',
    //             phone: '090299849',
    //             email: 'test@yopmail.com'
    //           },
    //         },
    //       },
  return data.map((item: any) => ({
    id: item.id,
    subject: {
      thumb: item.subject.thumb,
      title: item.subject.title,
      attrs: item.subject.attrs,
      map: item.subject.map,
      region: item.subject.region,
      address: item.subject.address,
      owner: item.subject.owner,
      broker: item.subject.broker,
    },
    statistic: {
      deposit_price: item.statistic.deposit_price,
      min_price: item.statistic.min_price,
      max_price: item.statistic.max_price,
      total: item.statistic.total,
    },
    deal: {
      deal_price: item.deal.deal_price,
      owner: item.deal.owner,
      broker: item.deal.broker,
    }
  }))
}

const getAttrs = () => {
  // [{ key: 'Diện tích', val: 300 }, { key: 'Số tầng', val: 5 }, { key: 'Số phòng', val: 10 }]
  return [{ key: 'Diện tích', val: 300 }, { key: 'Số tầng', val: 5 }, { key: 'Số phòng', val: 10 }]
}

const getRegion = (realEstate: any) => {
  //"Hải Châu, Đà Nẵng",
  return realEstate.district.name + ', ' + realEstate.province.name
}

const getMap = (listing: any) => {
  //{ map_sheet: '30', plot_num: '10' }
  return { map_sheet: listing.map_sheet_number, plot_num: listing.plot_number }
}

const getOwner = (owner: any) => {
  // {
  //   id: 248,
  //   profile_pic: 'https://images.unsplash.com/photo-1602866813929-6bc4933c7013?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  //   code: '#56333',
  //   full_name: 'Nguyễn Văn A',
  //   phone: '090299849',
  //   email: 'test@yopmail.com'
  // }

  return {
    id: owner?.id,
    profile_pic: owner?.avatar?.url?.thumbnail,
    code: owner?.code,
    full_name: owner?.full_name,
    phone: owner?.phone_number,
    email: owner?.email
  }
}

const getBroker = (broker: any) => {
  // {
  //   id: 248,
  //   profile_pic: 'https://images.unsplash.com/photo-1602866813929-6bc4933c7013?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  //   code: '#56333',
  //   full_name: 'Nguyễn Văn A',
  //   phone: '090299849',
  //   email: 'test@yopmail.com'
  // }

  return {
    id: broker?.broker_profile?.id,
    profile_pic: broker?.avatar?.url?.thumbnail,
    code: broker?.code,
    full_name: broker?.full_name,
    phone: broker?.phone_number,
    email: broker?.email
  }
}

const getStatusBid = (bid: any, total: number, status: string) => {
  if(status === 'coming_soon'){
    return [{
      type: 'warn',
      label: 'Sắp diễn ra'
    }]
  }else if(status === 'ended'){
     if (bid) {
      return [{
        type: 'secondary',
        label: 'Đã thành công'
      }]
    }else{
      return [{
        type: 'secondary',
        label: 'Đã kết thúc'
      }]
    }
  }else {
    if (total > 0) {
      return [{
        type: 'warn',
        label: 'Đang chào giá'
      }]
    }else{
      return [{
        type: 'warn',
        label: 'Chưa có chào giá'
      }]
    }
  }
}

export const formatTableDataFlashOfferResult = (data: any) => {
    return data.map((item: any) => ({
      id: item.id,
      subject: {
        flash_offer_id: item.flash_offer_id,
        thumb: item?.listing?.photos[0]?.url?.medium || '',
        title: item.listing?.title,
        attrs: getAttrs(),
        map: item.listing ? getMap(item.listing) : { map_sheet: '', plot_num: '' }, //{ map_sheet: '30', plot_num: '10' },
        region: item.listing ? getRegion(item.listing.real_estate) : '', //"Hải Châu, Đà Nẵng",
        address: item.listing?.address || '',
        owner: item.listing?.contract?.seller,
        broker: item.listing?.contract?.seller_broker,
      },
      statistic: {
        deposit_price: item?.deposit,
        min_price: item?.min_bid_value,
        max_price: item?.max_bid_value,
        total: item?.total_bids,
      },
      deal: {
        status: getStatusBid(item?.successful_bid, item.total_bids, item.status),
        id: item?.successful_bid?.id,
        time: item?.successful_bid?.updated_at,
        deal_price: item?.successful_bid?.bid_amount,
        owner: item?.successful_bid?.customer,
        broker: item?.successful_bid?.broker,

      }
    }))
}
